import React from 'react'
import styles from './Wrapper.module.scss'

interface Props {
  children: React.ReactNode
}

export const TableWrapper = ({ children }: Props) => (
  <div className={styles.root}>
    {children}
  </div>
)
